import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from './PremiumSelector.module.css';

const PremiumSelector = ({onChange, defaultValue}) => {
    
    const { t } = useTranslation();
    const standard_monthly_remuneration = [58000, 68000, 78000, 88000, 98000, 104000, 110000, 118000, 126000, 134000, 142000, 150000, 160000, 170000, 180000, 190000, 200000, 220000, 240000, 260000, 280000, 300000, 320000, 340000, 360000, 380000, 410000, 440000, 470000, 500000, 530000, 560000, 590000, 620000, 650000, 680000, 710000, 750000, 790000, 830000, 880000, 930000, 980000, 1030000, 1090000, 1150000, 1210000, 1270000, 1330000, 1390000];
    const premium_rate = 0.043150;

    const [value, setValue] = useState(defaultValue);

    const handleChange = (value) => {
        setValue(value);
        onChange(value);
    }

    const formatNumber = (number) => {
        return new Intl.NumberFormat().format(number);
    }

    // 標準報酬月額 × 料率 の被保険者負担（折半）額（円未満切り捨て）
    const calcPremium = (remuneration) => {
        const sen = Math.round(remuneration * premium_rate * 100); // 銭単位で浮動小数点誤差を丸める
        return Math.floor(sen / 100); // 円未満切り捨て
    }

    return (
        <div className={styles.wrapper}>
            <select
                value={value}
                onChange={(e) => {handleChange(e.target.value)}}
                className={styles.select}
                >
                {standard_monthly_remuneration.map((val, index) => {
                return <option key={index} value={val}>{formatNumber(calcPremium(val))}</option>
                })}
            </select>
            <span className={styles.mark}>{t("円")}</span>
        </div>
      )
  }
  
  export default PremiumSelector;